import { RiBuildingLine } from "@itandi/itandi-bb-ui";
import { useState } from "react";
import { DealVendorChangeModal } from "~/components/common/deals/show/vendor_card/DealVendorChangeModal";
import { EditMenuButton } from "~/components/common/parts/button/EditMenuButton";
import { useVendorSessionContext } from "~/context/VendorSession";
import type { Deal } from "~/models/Deal";
import {
	getSubDealVendor,
	isSameVendor,
	isSubVendor
} from "~/models/DealVendorCompany";
import Styles from "../DealCard.module.scss";

type Props = {
	deal: Deal;
};

/**
 * Vendorが2次請け構造のとき、1次請けの会社情報を表示する
 * 1次請けと2次請けが同じ施工会社の場合は表示しない
 *
 * @constructor
 * @for vendor
 */
export function DealSubVendorCard({ deal }: Props) {
	const [isOpen, setIsOpen] = useState(false);
	const session = useVendorSessionContext();
	const dealVendor = getSubDealVendor(deal);

	if (dealVendor === null || isSameVendor(deal)) {
		return null;
	}

	return (
		<div className={Styles.DealCard}>
			<h3 className={Styles.Title}>
				<RiBuildingLine className={Styles.TitleIcon} />
				実施会社情報
				{isSubVendor(deal, session.vendorCompany.id) && (
					<div className={Styles.EditButtonWrapper}>
						<EditMenuButton
							onClick={() => {
								setIsOpen(true);
							}}
						>
							変更
						</EditMenuButton>
						{isOpen ? (
							<DealVendorChangeModal
								dealVendorCompany={dealVendor}
								handleClose={() => {
									setIsOpen(false);
								}}
							/>
						) : null}
					</div>
				)}
			</h3>
			<div className={Styles.Content}>
				<dl className={Styles.ListContent}>
					<dt className={Styles.ListContentCaption}>会社名</dt>
					<dd className={Styles.ListContentValue}>
						{dealVendor.vendorCompany?.name}
					</dd>
				</dl>
				<dl className={Styles.ListContent}>
					<dt className={Styles.ListContentCaption}>担当者</dt>
					<dd className={Styles.ListContentValue}>
						{dealVendor.user === null ? (
							<span className={Styles.NotYet}>未定</span>
						) : (
							<>
								<div>{dealVendor.user.name}</div>
								<div>
									<a
										className={Styles.Link}
										href={`tel:${dealVendor.user.tel}`}
									>
										{dealVendor.user.tel}
									</a>
								</div>
								<div>
									<a
										className={Styles.Link}
										href={`mailto:${dealVendor.user.email}`}
									>
										{dealVendor.user.email}
									</a>
								</div>
							</>
						)}
					</dd>
				</dl>
			</div>
		</div>
	);
}
